import { FiletypeJsx } from "react-bootstrap-icons";

export const Footer = () => {
    return (
        <div className="footer-box">
            <p><FiletypeJsx size={22} />Created & Coded by Ọmọohwó</p>
        </div>
    )
}